<template>
		<div class="mt-5">
			<template v-if="!loading">
				<v-row class="ml-0" v-if="listRewardGroup.length > 0">
					<v-col cols="12" sm="12" md="6" class="pl-0 pb-0 flex-stretch" v-for="reward in listRewardGroup" :key="reward.reward_id">
						<v-card class="elevation-0 rounded-lg hover-shadow fill-height">
							<div class="d-flex flex-wrap">
								<v-col cols="12" sm="4" md="5" class="d-flex flex-column align-center fill-height pa-4">
									<v-img width="80%" elevation="2" class="mx-auto hover-shadow" :src="(reward.reward_image_url) ? reward.reward_image_url : '/assets/icon/reward.svg'"></v-img>
									<div class="bottom-shadow"></div>
								</v-col>
								<v-col cols="12" sm="8" md="7" class="pl-0 pt-5 align-start">
									<div class="pt-2 pb-3 px-3">
										<div class="font-size-14 cl-primary font-weight-600 text-uppercase">{{ reward.reward_bonus }}</div>
									</div>
									<div class="d-flex flex-wrap">
										<v-col cols="12" class="pb-0 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Syarat Point Kiri</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_point_left }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Syarat Point Kanan</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_point_right }}</div>
										</v-col>
									</div>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listRewardGroup.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data reward yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>

				<div class="mt-3" v-if="listRewardGroup.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="rewardGroupPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ rewardGroupPagination.total_display }} data dari total {{ rewardGroupPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</template>

			<template v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</template>
		</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
		}
	},
	computed: {
		...mapState('reward', ['listRewardGroup', 'rewardGroupPagination']),
	},
	methods: {
		...mapActions('reward', ['getRewardGroup']),

		getData() {
			this.loading = true
			this.getRewardGroup(this.queryString({limit:this.limit, page: this.page, params:this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `List Reward Group`)
		this.getData()
	}
};
</script>

